module.exports = __webpack_public_path__ + "media/images/pages/careers-week/risa-91159778a45c4c35729419b5f65bb91a.jpg";